//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    UNIT_TYPE_EVENT_DELETE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    unitTypeEventDeleteResult,
} from 'Redux/actions';


function* deleteUnitTypeEvent({ payload }) {
    try {
        let mutationdeleteUnitTypeEvent = `mutation {`
        let QUERY = `
            mutation deleteUnitTypeEvent ($id: Int) {
                result: deleteUnitTypeEvent (id: $id)
            }
        `;

        payload.map((item, index) =>{
            mutationdeleteUnitTypeEvent += `
                    UnitTypeEventDelete${index}: deleteUnitTypeEvent(id: ${item})
            `
        })

        mutationdeleteUnitTypeEvent += ` } `

        let data = yield call(
            clientMutation,
            mutationdeleteUnitTypeEvent,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        if (data) {
            yield put(unitTypeEventDeleteResult(data))
        } else yield put(unitTypeEventDeleteResult())

    } catch (exc) {
        yield put(unitTypeEventDeleteResult())
        ExceptionManager(exc, 'Modules/events/views/.components/deleteUnitTypeEvent/redux/saga', 'deleteUnitTypeEvent', true);
    }
}

function* watchEventRequests() {
    yield takeEvery(UNIT_TYPE_EVENT_DELETE_REQUEST, deleteUnitTypeEvent);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchEventRequests)
    ]);
}